import { useCallback, useEffect, useState } from "react";
import { listSuperAgents } from "./workerLineApi.js";

export const SUPER_AGENTS_DEFAULT_PAGE_SIZE = 25;

/**
 * Fetches GET /api/backoffice/worker-line/super-agents with real server-side
 * pagination/filtering - mirrors ../geofence/useGeofenceZonesList.js.
 * Refetches every time `filters` changes (search, status, page, pageSize).
 *
 * `filters` must be a stable object reference (the caller should build it
 * with useMemo) - the effect depends on the object directly so it only
 * re-runs when a real filter value actually changes, not on every render.
 * Search debouncing is the caller's responsibility, not this hook's.
 */
export function useSuperAgentsList(filters) {
  const [state, setState] = useState({ status: "loading", data: null, error: null });
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    // Previous data (if any) stays visible while a refetch is in flight.
    setState((previous) => ({ status: "loading", data: previous.data, error: null }));

    listSuperAgents(filters)
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState((previous) => ({ status: "error", data: previous.data, error }));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [filters, reloadToken]);

  const refetch = useCallback(() => setReloadToken((token) => token + 1), []);

  return { ...state, refetch };
}
